<template>
  <div class="account-notification" id="page-notification">
    <div class="notification-inner" :class="{visible: $props.visible}">
      <transition name="delayed-fade" mode="out-in">
        <p v-if="$props.visible"><span class="title"><i class="icon-sc-info"></i> {{ $t('accountWarningNotification.title') }}</span>
          <span class="description">{{ $t('accountWarningNotification.description') }}</span>
          <span class="description" v-if="false">{{ $t('accountWarningNotification.descriptionWithDate', { date: getFinalPaymentDate('tue') }) }}</span>
        </p>
      </transition>
    </div>
  </div>
</template>

<script>
import { endOfMonth, getISODay, addDays, format } from 'date-fns'

const daysOfWeekMap = {
  mon: 1,
  tue: 2,
  wed: 3,
  thu: 4,
  fri: 5,
  sat: 6,
  sun: 7
}
export default {
  name: 'account-warning-notification',
  props: {
    visible: Boolean
  },
  methods: {
    /**
     * U međuvremenu se odustalo od ovoga, ali ću ostaviti ako ikada bude zatrebalo
     * treba odkomentarisati span sa klasom description, a drugi zakomentarisati, ako ovo treba da se koristi
     * @param dayOfWeek {string} - Poslednji dan u mesecu za koji nam treba datum
     * @param fromDate
     * @returns {string}
     */
    getFinalPaymentDate (dayOfWeek, fromDate = new Date()) {
      // calculate offset to get the day passed in argument and decrease for one extra day
      const offsetDays = -(getISODay(endOfMonth(fromDate)) - daysOfWeekMap[dayOfWeek]) - 1
      const lastRequestedDayInWeek = addDays(endOfMonth(fromDate), offsetDays)

      return format(lastRequestedDayInWeek, 'dd.MM.yyyy.')
    }
  }
}
</script>

<style scoped lang="scss">
.account-notification {
  background-color: $success;
  color: $white;

  .notification-inner {
    margin: 0 auto;
    height: 0;

    @media (map_get($breakpoints, md)) {
      max-width: 960px;
    }

    @media (map_get($breakpoints, lg)) {
      max-width: 1240px;
    }

    @media (map_get($breakpoints, xxl)) {
      max-width: 1600px;
    }

    &.visible {
      padding: 1rem 3.9rem 1rem 2rem;
      height: auto;

      @media (map_get($breakpoints, md)) {
        padding-left: 0;
        padding-right: 0;
      }
    }

    p {
      font-size: 1.4rem;
      margin-bottom: 0;
      display: flex;

      span.title {
        padding-right: 1.6rem;
        border-right: 1px solid $white;
        margin-right: 1.6rem;
        font-weight: 500;
        white-space: nowrap;
        display: flex;
        align-items: center;

        i {
          vertical-align: -1px;
          margin-right: 5px;
        }
      }

      span.description {
        flex: 1 1 auto;
        margin: auto 0;
      }
    }
  }
}
</style>
